import React from 'react';

/**
 * SuperFecher에서 전역 로딩을 해주고 있어서 임시로 빈 요소 리턴
 * @todo SuperFetch의 전역 로딩 제거 후 스피너 리턴하도록 수정
 * */
const FullPageSpinner = () => {
  return <></>;
};

export default FullPageSpinner;
